import { BasicRequest } from "./basicRequest";

export class AdminChangePasswordRequest extends BasicRequest{
    
    public userId! : number;
    public newPwd! : string;

    constructor(){
        super()
    }
}